module.exports = __webpack_public_path__ + "img/receipt.2fe32c8.png";